<template>
  <div id="prderPage" v-if="data">
    <!-- 确认订单标题 -->
    <div class="nav">
      <img src="../assets/img/箭头 (3).png" alt class="back" @click="goback" />
      确认订单
    </div>
    <!-- 地址栏 -->
    <div class="address" v-if="hide" @click="addresspage">
      <div class="userInfo">
        <span class="receiver">收货人</span>
        {{cart2Data.addressList.consignee}}
      </div>
      <div class="userNum">
        <span>电话</span>
        {{cart2Data.addressList.mobile}}
      </div>
      <div class="user-address">
        <div>
          <img src="../assets/img/定位.png" alt class="locat" />
          <span class="receiver-add">收获地址</span>
        </div>
        <span class="detail-pro">{{detailAddress}}{{cart2Data.addressList.address}}</span>
      </div>
      <div class="edit">
        <img src="../assets/img/编辑.png" alt />
      </div>
    </div>
    <div class="tempAddress" v-else @click="addresspage">
      <div class="addlogo">
        <img src=".././assets/img/空地址.png" alt />
      </div>
      <div class="addtext">点击添加收货地址</div>
    </div>
    <!-- 店铺信息 -->
    <div class="shop">
      <div class="shop-l">
        <img src="../assets/img/店铺.png" alt class="shopimg" />
        <span class="shop-name">{{cart2Data.storeShippingCartList[0].store_name}}</span>
      </div>
      <div class="show-goods">
        <div>
          <img
            :src="'http://youwei.jingmaie-co.cn/'+cart2Data.storeShippingCartList[0].cartList[0].goods.original_img"
            alt
            class="show-goods-img"
          />
        </div>
        <div>
          <span class="show-text">
            {{cart2Data.storeShippingCartList[0].cartList[0].goods_name}}
            <br />
          </span>
          <span class="show-price">
            <span
              class="show-price-l"
            >{{cart2Data.storeShippingCartList[0].cartList[0].market_price}}</span>
            <span class="show-price-r">
              ￥ {{cart2Data.storeShippingCartList[0].cartList[0].market_price}}
              <span>x {{cart2Data.storeShippingCartList[0].cartList[0].goods_num}}</span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <!-- 配送方式 -->
    <div class="delivery">
      <span class="delivery-type">
        <span class="delivery-type-l">配送方式</span>
      </span>
      <span>
        快递
        <span class="freight">￥{{shipping_price}}</span>
      </span>
    </div>
    <!-- 买家留言 -->
    <div class="message">
      <span class="message-l">买家留言</span>
      <input
        type="text"
        class="message-r"
        v-model="remarks"
        placeholder="选填，填写内容已和卖家协商确认"
        @blur="onblur"
      />
    </div>
    <!-- 共计 -->
    <div class="total">
      <div class="total-r">
        <span class="total-n">共{{total_num}}件商品</span>
        <span class="total-s">小计:</span>
        <span class="total-p">￥{{total_amount}}</span>
      </div>
    </div>
    <!-- 提交订单 -->
    <div class="Submission">
      <div class="Submission-b">
        <span class="subtotal">
          共{{total_num}}件 需要支付：
          <span style="color:#ff544f">￥{{total_amount}}</span>
        </span>
        <span @click="showPopup" class="Submit">立即支付</span>
        <van-popup v-model="show" position="bottom">
          <div class="pay-method">
            <!-- 多个付款方式时使用 -->
            <div v-for="(item,index) in Payment" :key="index" class="paybox">
              <img :src="'http://youwei.jingmaie-co.cn'+item.icon" alt />
              <span>{{item.name}}</span>
              <input type="radio" name="pay" @click.stop="chose(item)" />
            </div>
            <div class="payment">
              <a
                href="javascript:void(0)"
                class="payment"
                @click="payMoney"
              >确认支付{{total_amount}}元</a>
            </div>
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import { Cart2, Cart3, setting, payInfo } from "@/api";
export default {
  data() {
    return {
      data: false, //解决数据未请求完先渲染问题
      hide: true, //收获地址显示隐藏
      checked_nm: false, //是否勾选匿名购买
      show: false, //是否显示
      checked_zfb: "", //是否勾选付款方式
      orderData: "", //生成订单信息
      cart2Data: "", //cart2接口信息
      cart3Data: "", //cart3接口信息
      detailAddress: "", //详细地址
      remarks: "", //买家留言
      roomNum: "", //房间号
      orderSn: "", //订单号
      radio: "", //选择付款方式
      Payment: "", //支付配置列表
      type: "", //支付类型
      paycode: "", //支付方式
      payList: "", //用户选择的支付方式
      shipping_price:'',//运费
      total_num:'',//总数
      total_amount:'',//总价
    };
  },
  created() {
    //接收生成订单时的信息
    this.getorder();
  },
  methods: {
    // input失去焦点 页面回到原位置
    onblur() {
      document.body.scrollTop = 0;
    },
    // 返回上一页
    goback() {
      this.$router.go("-1");
    },
    // 跳转添加地址管理页面
    addresspage() {
      this.$router.push("addressPage");
    },
    // 获取cart2信息
    async getorder() {
      this.orderData = eval("(" + this.$route.query.orderData + ")");
      let params = {
        goods_id: this.orderData.goods_id, //商品id
        goods_num: this.orderData.goods_num, //商品数量
        item_id: this.orderData.item_id, //商品规格id
        address_id: this.orderData.address_id, //用户默认地址
        token: this.orderData.token, //token
        action: "buy_now"
      };
      let res = await Cart2(qs.stringify(params));
      if (res.status == 1) {
          this.data = true;
          // 没有地址时
        if (res.result.addressList.address_id == undefined) {
          this.hide = false;
          this.cart2Data = res.result;
        } else {
          let choseAddress = JSON.parse(
            window.sessionStorage.getItem("choseAddress")
          );
          if (choseAddress == null) {
            this.hide = true;
            this.cart2Data = res.result;
          } else {
            this.hide = true;
            this.cart2Data = res.result;
            this.cart2Data.addressList.consignee = choseAddress.consignee;
            this.cart2Data.addressList.mobile = choseAddress.mobile;
            this.cart2Data.addressList.address = choseAddress.address;
            this.cart2Data.addressList.address_id = choseAddress.address_id;
            this.detailAddress =
              choseAddress.province_name +
              choseAddress.city_name +
              choseAddress.district_name;
          }
        }
        this.getCart3(this.cart2Data.addressList.address_id);
      } else if (res.status == -101) {
        window.localStorage.removeItem("token");
        this.$router.push("index");
      }
    },
    // 获取cart3数据
    async getCart3(id) {
      let params = {
        address_id: id,
        action: "buy_now",
        act: "order_price",
        goods_id: this.orderData.goods_id,
        item_id: this.orderData.item_id,
        goods_num: this.orderData.goods_num,
        token: this.orderData.token
      };
      let res = await Cart3(qs.stringify(params));
      if (res.status == 1) {
        this.shipping_price = res.result.shipping_price
        this.total_amount =  res.result.total_amount
        this.total_num = res.result.total_num
      } else if (res.status === -101) {
        window.localStorage.removeItem("token");
        this.$router.push("index");
      }else if(res.status===-1) {
        this.$toast({message:res.msg,duration:'2000'}) 
        this.total_num = this.cart2Data.cartGoodsTotalNum
        this.total_amount = this.cart2Data.storeCartTotalPrice
        this.shipping_price = 0
      }
    },
    // 是否显示付款方式弹出框
    async showPopup() {
      let asd = [
        { goodsNum: this.orderData.goods_num },
        { user_note: this.remarks }
      ];
      let params = {
        address_id: this.cart2Data.addressList.address_id,
        action: "buy_now",
        act: "submit_order",
        goods_id: this.orderData.goods_id,
        item_id: this.orderData.item_id,
        goods_num: this.orderData.goods_num,
        token: this.orderData.token,
        cart_form_data: JSON.stringify(asd)
      };
      let res = await Cart3(qs.stringify(params));
      if (res.status === 1) {
        this.orderSn = res.result.master_order_sn;
        this.proyx(this.orderSn);
      } else if (res.status === -101) {
        window.localStorage.removeItem("token");
        this.$router.push("index");
      } else if(res.status===-1){
        this.$toast({message:res.msg,duration:'2000'}) 
        this.addresspage()
      }
    },
    // 支付配置，获取支付信息列表
    async proyx(id) {
      let params = {
        token: this.orderData.token,
        master_order_sn: id,
        scene:4
      };
      let res = await setting(params);
      console.log(res)
      if (res.status === 1) {
        // Payment 获取场景值为4的付款列表
        this.Payment = res.result.filter(item => {
          return item.scene === 4;
        });
        // 判断是否有微信支付宝支付
        if (this.Payment.length === 0) {
          this.show = false;
          this.$toast("此功能暂未开通");
        } else {
          //判断是否在微信打开
          var userAgent = navigator.userAgent.toLowerCase();
          if (userAgent.match(/MicroMessenger/i) == "micromessenger") {
            this.Payment = this.Payment.filter(item => {
              return item.code != "webAliPay";
            });
            this.show = true;
          } else {
            // alert('浏览器')
            this.show = true;
          }
          this.show = true;
        }
      } else if (res.status === -101) {
        window.localStorage.removeItem("token");
      }
    },
    // 用户选择的付款方式信息
    chose(item) {
      this.payList = item;
    },
    // 根据用户选择的付款方式 调用付款页面
    async payMoney() {
      let params = {
        type: this.payList.payment_type_id,
        token: this.orderData.token,
        master_order_sn: this.orderSn,
        paycode: this.payList.code
      };
      let res = await payInfo(qs.stringify(params));
      if (res.status === 1) {
        // 支付宝支付
        if (res.result.payinfo.mweb_url == undefined) {
          const div = document.createElement("divform");
          div.innerHTML = res.result.payinfo;
          document.body.appendChild(div);
          document.forms[0].submit();
        } else {
          // 微信支付
          window.location.href = res.result.payinfo.mweb_url;
        }
      } else if (res.status === -101) {
        window.localStorage.removeItem("token");
        this.$router.push("index");
      }
    }
    // 判断网页是在支付宝/微信/浏览器打开
    // isAlipayOrWechat() {
    //   var userAgent = navigator.userAgent.toLowerCase();
    //   if (userAgent.match(/Alipay/i) == "alipay") {
    //     alert("支付宝浏览器");
    //     this.WeChat = false;
    //   } else if (userAgent.match(/MicroMessenger/i) == "micromessenger") {
    //     alert("微信浏览器");
    //     this.Alipay = false;
    //   } else {
    //     alert('浏览器')
    //   }
    // }
  }
};
</script>
<style lang="less" scoped>
#prderPage {
  width: 750px;
  height: 95vh;
  background-color: #f6f6f6;
  padding: 80px 0 0;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  font-size: 28px;
  .nav {
    width: 750px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    font-size: 26px;
    color: #000000;
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    .back {
      width: 15px;
      height: 27px;
      float: left;
      margin-top: 30px;
      margin-left: 31px;
    }
  }
  .address {
    width: 750px;
    margin: 10px 0;
    padding: 22px 76px;
    font-size: 24px;
    box-sizing: border-box;
    background-color: #fff;
    position: relative;
    .userInfo {
      .receiver {
        display: inline-block;
        text-align: right;
        width: 120px;
        color: #7a797a;
        letter-spacing: 8px;
        margin-right: 20px;
        font-size: 26px;
      }
    }
    .userNum {
      margin: 10px 0;
      span {
        display: inline-block;
        width: 120px;
        text-align: right;
        color: #7a797a;
        letter-spacing: 8px;
        text-align: right;
        margin-right: 20px;
        font-size: 26px;
      }
    }
    .user-address {
      display: flex;
      .locat {
        display: inline-block;
        width: 22px;
        height: 29px;
        margin-left: -40px;
      }
      .receiver-add {
        display: inline-block;
        text-align: right;
        color: #7a797a;
        width: 130px;
        margin-left: 4px;
        margin-right: 10px;
        font-size: 26px;
      }
      .detail-pro {
        display: inline-block;
        margin-left: 20px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .edit {
      position: absolute;
      top: 10px;
      right: 50px;
      img {
        width: 120px;
        height: 70px;
      }
    }
  }
  .tempAddress {
    background-color: #fff;
    margin: 10px 0;
    width: 750px;
    height: 250px;
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
    .addlogo {
      margin: 20px 0;
      img {
        margin: 0 auto;
      }
    }
    .addtext {
      color: #686868;
    }
  }
  .shop {
    width: 750px;
    height: 272px;
    background-color: #fff;
    padding: 0 30px 29px 30px;
    margin: 0;
    box-sizing: border-box;
    .shop-l {
      height: 79px;
      width: 696px;
      line-height: 79px;
      border-bottom: 1px solid #c2c2c2;
      .shopimg {
        width: 31px;
        height: 31px;
      }
      .shop-name {
        margin-left: 15px;
        font-size: 24px;
        color: #7a797a;
      }
    }
    .line {
      width: 690px;
      height: 1px;
      // margin: 26px 0 22px 0;
      color: #c2c2c2;
      background-color: #c2c2c2;
    }
    .show-goods {
      display: flex;
      justify-content: space-between;
      margin-top: 22px;
      .show-goods-img {
        display: inline-block;
        height: 140px;
        width: 140px;
        margin-right: 24px;
      }
      .show-text {
        width: 502px;
        display: inline-block;
        height: 50px;
        line-height: 50px;
        font-size: 24px;
        color: #000000;
        margin-top: 10px;
      }
      .show-price {
        display: flex;
        justify-content: space-between;
        margin-top: 28px;
      }
      .show-price-l {
        font-size: 28px;
        color: #7a797a;
      }
      .show-price-r {
        font-size: 28px;
        color: #ff544f;
        span {
          color: #000000;
          margin-left: 10px;
        }
      }
    }
  }
  .buy {
    width: 750px;
    height: 151px;
    background-color: #fff;
    padding: 32px 30px;
    box-sizing: border-box;
    color: #7a797a;
    .buy-num {
      display: flex;
      justify-content: space-between;
      .buy-num-l {
        font-size: 24px;
      }
      .buy-num-r {
        height: 44px;
        display: inline-block;
        .sub,
        .add {
          display: inline-block;
          width: 60px;
          height: 40px;
          line-height: 40px;
          color: #c2c2c2;
          font-size: 32px;
          text-align: center;
          background-color: #f5f5f5;
        }
        .num-val {
          display: inline-block;
          width: 80px;
          height: 40px;
          font-size: 32px;
          line-height: 40px;
          margin: 0 5px;
          text-align: center;
          color: #6d6d6d;
          background-color: #f5f5f5;
        }
      }
    }
    .buy-price {
      margin-top: 26px;
      display: flex;
      justify-content: space-between;
      .buy-price-l {
        font-size: 24px;
      }
      .buy-price-2 {
        color: #ff544f;
        font-size: 28px;
      }
    }
  }
  .delivery {
    height: 87px;
    line-height: 60px;
    width: 750px;
    padding: 13px 30px;
    margin: 10px 0;
    font-size: 28px;
    color: #000000;
    background-color: #fff;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .delivery-type-l {
      color: #7a797a;
      margin-right: 69px;
    }
    .freight {
      color: #ff544f;
      font-size: 28px;
      margin-left: 19px;
    }
  }
  .message {
    width: 750px;
    background-color: #fff;
    padding: 32px 31px;
    font-size: 28px;
    .message-l {
      color: #7a797a;
    }
    .message-r {
      margin-left: 40px;
      width: 500px;
      border: none;
      color: #7a797a;
    }
  }
  .room {
    width: 750px;
    background-color: #fff;
    padding: 32px 31px;
    margin: 10px 0;
    .roomTitle {
      font-size: 24px;
      color: #7a797a;
    }
    .roomNumber {
      margin-left: 60px;
      width: 400px;
      border: none;
      font-size: 16px;
      color: #7a797a;
    }
  }
  .total {
    width: 750px;
    height: 74px;
    background-color: #fff;
    padding: 22px 28px;
    margin-top: 10px;
    box-sizing: border-box;
    .total-r {
      float: right;
      .total-s {
        margin: 0 10px 0 20px;
      }
      .total-p {
        color: #ff544f;
      }
    }
  }
  .anonymous {
    padding: 25px 31px;
    height: 128px;
    display: flex;
    justify-content: space-between;
    font-size: 24px;
    .anonymousTitle {
      font-size: 24px;
    }
    .anonymousChoice {
      /deep/ .van-checkbox__icon {
        border: 2px solid rgb(131, 128, 128);
        border-radius: 50%;
      }
    }
  }
  .Submission {
    width: 750px;
    height: 110px;
    padding-top: 15px;
    background-color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    .Submission-b {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      .subtotal {
        display: inline-block;
        width: 70%;
        text-align: right;
        height: 125px;
        line-height: 100px;
        padding-right: 20px;
      }
      .Submit {
        display: inline-block;
        background-color: #ff544f;
        width: 200px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        color: #fff;
        border-radius: 45px;
        margin: 0;
        transform: translateY(-10px);
      }
      /deep/ .van-overlay {
        width: 750px;
      }
      /deep/ .van-popup {
        width: 750px;
      }
      .pay-method {
        width: 750px;
        height: 40%;
        background-color: #fff;
        box-sizing: border-box;
        padding-bottom: 60px;
        position: relative;
        .paybox {
          width: 90%;
          height: 130px;
          position: relative;
          align-items: center;
          margin: 30px;
          border-bottom: 1px solid #cccccc;
          box-sizing: border-box;
          img {
            width: 100px;
            height: 100px;
            vertical-align: middle;
          }
          input {
            position: absolute;
            right: 0;
            top: 10px;
            width: 60px;
            height: 60px;
          }
          span {
            display: inline-block;
            vertical-align: middle;
            margin: 0 20px;
            font-size: 28px;
          }
        }
        .payment {
          width: 750px;
          height: 80px;
          text-align: center;
          line-height: 80px;
          font-size: 28px;
          color: #ffffff;
          background-color: #ff544f;
          position: fixed;
          bottom: 0;
          left: 0;
          z-index: 999;
        }
      }
    }
  }
}
</style>